<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                </div>
                <div class="title">
                    <a>
                        <img src="images/common/img_logo.png" alt="" />
                    </a>
                </div>
            </div>
        </header>
        <!-- // header -->
        <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
        <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />

        <div id="content-wrap">
            <div id="contents">
                <div class="main-wrapper">
                    <div class="main-top">
                        <div class="user-info">
                            <p v-text="constructionNm" />
                            <P class="nm" v-text="name" />
                        </div>
                        <div class="task-cnt">
                            <!-- 작성자 기준으로 그 외는 나 기준 결재대기, 결재완료, 결재진행중인 것으로 구분하자 -->
                            <ul>
                                <li>
                                    <a @click="moveList('myApproval')">
                                        <span class="approveState my-waiting">내 결재대기</span>
                                        <span class="cnt" v-text="datas.myApprovalWaiting" />
                                    </a>
                                </li>
                                <li>
                                    <a @click="moveList('request')">
                                        <span class="approveState request">작성중</span>
                                        <span class="cnt" v-text="datas.request" />
                                    </a>
                                </li>
                                <li>
                                    <a @click="moveList('waiting')">
                                        <span class=" approveState waiting">결재중</span>
                                        <span class="cnt" v-text="datas.waiting" />
                                    </a>
                                </li>
                                <li>
                                    <a @click="moveList('approve')">
                                        <span class="approveState approve">결재완료</span>
                                        <span class="cnt" v-text="datas.approve" />
                                    </a>
                                </li>
                                <li>
                                    <a @click="moveList('approve')">
                                        <span class="approveState approve">반려결재</span>
                                        <span class="cnt" v-text="datas.reject" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="main-quick">
                        <ul>
                            <li>
                                <a class="quick-1" @click="movePage('Step1')">
                                    <span>Face Mapping<br />Registration</span>
                                </a>
                            </li>
                            <li>
                                <a class="quick-2" @click="movePage('List')">
                                    <span>Face Mapping<br />List</span>
                                </a>
                            </li>
                            <li>
                                <a class="quick-3" @click="movePage('SlideNATM')">
                                    <span>NATM/TBM<br />Slide Show</span>
                                </a>
                            </li>
                            <li>
                                <a class="quick-4" @click="movePage('ThreeDimensional')">
                                    <span>3D Map<br />Show</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="main-list-summary">
                        <div class="summary-box">
                            <div class="summary-top">
                                <a @click="movePage('SlideNATM')">NATM Slide Show</a>
                            </div>
                            <div class="summary-body">
                                <ul>
                                    <li
                                        v-for="(data, index) in datas.natmList"
                                        :key="index"
                                        @click="
                                            detail(
                                                data.tunnelConstructionMethod,
                                                data.constructionCode,
                                                data.id,
                                                data.approveState
                                            )
                                        "
                                    >
                                        <a>
                                            <div v-if="data.threeDimensionalImageUrl" class="thumb">
                                                <img
                                                    :src="fileUrl + data.threeDimensionalImageUrl"
                                                    :alt="fileUrl + data.threeDimensionalImageUrl"
                                                    @error="imgError"
                                                />
                                            </div>
                                            <div v-else class="thumb">
                                                <img
                                                    :src="fileUrl + data.frontImageUrl"
                                                    :alt="fileUrl + data.frontImageUrl"
                                                    @error="imgError"
                                                />
                                            </div>
                                            <span>
                                                <span>{{ data.station }}</span>
                                                <span
                                                    v-if="data.approveState == 'request'"
                                                    class="approveState request main-state-tag"
                                                >
                                                    작성중
                                                </span>
                                                <span
                                                    v-if="data.approveState == 'waiting'"
                                                    class="approveState waiting main-state-tag"
                                                >
                                                    결재요청(결재중)
                                                </span>
                                                <span
                                                    v-if="data.approveState == 'approve'"
                                                    class="approveState approve main-state-tag"
                                                >
                                                    결재완료
                                                </span>
                                                <span
                                                    v-if="data.approveState == 'reject'"
                                                    class="approveState approve main-state-tag"
                                                >
                                                    반려
                                                </span>
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="summary-box">
                            <div class="summary-top">
                                <a @click="movePage('SlideTBM')">TBM Slide Show</a>
                            </div>
                            <div class="summary-body">
                                <ul>
                                    <li
                                        v-for="(data, index) in datas.tbmList"
                                        :key="index"
                                        @click="
                                            detail(
                                                data.tunnelConstructionMethod,
                                                data.constructionCode,
                                                data.id,
                                                data.approveState
                                            )
                                        "
                                    >
                                        <a>
                                            <div class="thumb">
                                                <img
                                                    :src="fileUrl + data.tbmLeftImageUrl"
                                                    :alt="fileUrl + data.tbmLeftImageUrl"
                                                    @error="imgError"
                                                />
                                            </div>
                                            <span>{{ data.station }}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../api/FacemappingApi';
import LoginApi from '../api/LoginApi';
//import { allRemoveCookie } from '../utils/cookie';
import {
    AUTO_YN,
    CONSTRUCTION,
    CONSTRUCTION_NM,
    FILE_URL,
    JWT_REFRESH_TOKEN,
    JWT_TOKEN,
    MEMBER_ID,
    NAME,
    NO_IMG,
    PAGINATION,
    PARAM_OBJECT,
    TUNNEL_CONSTRUCTION,
    TYPE
} from '../const';
import gnb from './layout/gnb.vue';

export default {
    name: 'Main',
    components: {
        gnb
    },
    data: () => {
        return {
            datas: [],
            name: '',
            constructionNm: '',
            gnbShow: '',
            fileUrl: '',
            authType: 'observer'
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.$store.dispatch('showLoading');
    },
    created() {},
    mounted() {
        this.hideLoading();
        this.name = localStorage.getItem(NAME);
        this.authType = localStorage.getItem(TYPE);
        this.constructionNm =
            localStorage.getItem(CONSTRUCTION_NM) === null || localStorage.getItem(CONSTRUCTION_NM) === 'null'
                ? ''
                : localStorage.getItem(CONSTRUCTION_NM);
        this.facemappingList();
        this.fileUrl = FILE_URL;
        // param 초기화
        localStorage.removeItem(PARAM_OBJECT);
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        imgError(e) {
            e.target.src = NO_IMG;
        },
        async logout() {
            await LoginApi.logout();
            localStorage.removeItem(CONSTRUCTION_NM);
            localStorage.removeItem(CONSTRUCTION);
            localStorage.removeItem(NAME);
            localStorage.removeItem(TYPE);

            localStorage.removeItem(AUTO_YN);
            localStorage.removeItem(JWT_TOKEN);
            localStorage.removeItem(JWT_REFRESH_TOKEN);
            localStorage.removeItem(MEMBER_ID);

            this.$router.push({
                name: 'Login'
            });
        },
        async facemappingList() {
            this.showLoading();
            const data = await FacemappingApi.mainList({
                page: PAGINATION.number,
                rows: PAGINATION.main_numberOfElements,
                sort: 'RS.investigationDay',
                direction: 'desc'
            });

            this.datas = data.content;
            this.hideLoading();
        },
        write() {
            this.$router.push({
                name: 'Step1'
            });
        },
        list() {
            this.$router.push({
                name: 'List'
            });
        },
        detail(tunnelConstructionMethod, constructionCode, id, approveState) {
            if (tunnelConstructionMethod === TUNNEL_CONSTRUCTION.NATM) {
                if (approveState === 'request') this.$router.push({ path: `/step1/${id}` });
                else this.$router.push({ path: `/detail/${constructionCode}/${id}` });
            } else this.$router.push({ path: `/detailTBM/${constructionCode}/${id}` });
        },
        movePage(target) {
            this.$router.push({
                name: target
            });
        },
        moveList(target) {
            this.$router.push({ path: `/list/${target}` });
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
